/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Application_Overview_Company_1Inputs */

const en_landing_application_overview_company_1 = /** @type {(inputs: Landing_Application_Overview_Company_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example company`)
};

const de_landing_application_overview_company_1 = /** @type {(inputs: Landing_Application_Overview_Company_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beispielunternehmen`)
};

const fr_landing_application_overview_company_1 = /** @type {(inputs: Landing_Application_Overview_Company_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entreprise exemple`)
};

const es_landing_application_overview_company_1 = /** @type {(inputs: Landing_Application_Overview_Company_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresa de ejemplo`)
};

const it_landing_application_overview_company_1 = /** @type {(inputs: Landing_Application_Overview_Company_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azienda di esempio`)
};

const nl_landing_application_overview_company_1 = /** @type {(inputs: Landing_Application_Overview_Company_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorbeeldbedrijf`)
};

const pl_landing_application_overview_company_1 = /** @type {(inputs: Landing_Application_Overview_Company_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przykładowa firma`)
};

const fi_landing_application_overview_company_1 = /** @type {(inputs: Landing_Application_Overview_Company_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esimerkkiyritys`)
};

const da_landing_application_overview_company_1 = /** @type {(inputs: Landing_Application_Overview_Company_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksempelvirksomhed`)
};

const sv_landing_application_overview_company_1 = /** @type {(inputs: Landing_Application_Overview_Company_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exempelföretag`)
};

/**
* | output |
* | --- |
* | "Example company" |
*
* @param {Landing_Application_Overview_Company_1Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_application_overview_company_1 = /** @type {((inputs?: Landing_Application_Overview_Company_1Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Application_Overview_Company_1Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_application_overview_company_1(inputs)
	if (locale === "fr") return fr_landing_application_overview_company_1(inputs)
	if (locale === "es") return es_landing_application_overview_company_1(inputs)
	if (locale === "it") return it_landing_application_overview_company_1(inputs)
	if (locale === "nl") return nl_landing_application_overview_company_1(inputs)
	if (locale === "pl") return pl_landing_application_overview_company_1(inputs)
	if (locale === "fi") return fi_landing_application_overview_company_1(inputs)
	if (locale === "da") return da_landing_application_overview_company_1(inputs)
	if (locale === "sv") return sv_landing_application_overview_company_1(inputs)
	return en_landing_application_overview_company_1(inputs)
});